import React from "react";
import { CircularProgress } from "@mui/material";
import { useAuth } from "../../providers/Auth";
import { setEncryptSessionStorage } from "../../utils/EncryptStorage";
const Logout = () => {
  const auth = useAuth();

  React.useEffect(() => {
    auth.signOut();
    // prepare alert message
    const response = {
      showAlert: true,
      severity: "success",
      message: "all.alert.logout"
    };
    setEncryptSessionStorage("alertMessage", JSON.stringify(response));

    window.location.href.replace("login", "");
    
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div>
          <CircularProgress size={60} />
        </div>
      </div>
    </>
  );
};

export default Logout;
